// src/features/filesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const filesSlice = createSlice({
  name: 'files',
  initialState: {
    files: [],
    error: null,
  },
  reducers: {
    setFiles: (state, action) => {
      state.files = action.payload;
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearFiles: (state) => {
      state.files = [];
      state.error = null;
    },
  },
});

export const { setFiles, setError, clearFiles } = filesSlice.actions;
export default filesSlice.reducer;